import { createSortOption } from "@nosto/preact"
export const sizes = [24, 36, 48, 54, 72]

export const currency = window.Shopify?.currency?.active;

export const sortOptions = [
	createSortOption("score", "Featured", { field: "_score", order: "desc" }),
	createSortOption("revenue", "Popular", { field: "stats.revenue", order: "desc" }),
	createSortOption("name", "Name (A-Z)", { field: "name", order: "asc" }),
	createSortOption("-name", "Name (Z-A)", { field: "name", order: "desc" }),
	createSortOption("price", "Price (ASC)", { field: "price", order: "asc" }),
	createSortOption("-price", "Price (DESC)", { field: "price", order: "desc" }),
	createSortOption("date", "Newest", { field: "datePublished", order: "desc" }),
	createSortOption("-date", "Oldest", { field: "datePublished", order: "asc" }),
	// createSortOption("rating", "Top Rated: Lowest - Highest", { field: "ratingValue", order: "asc" }),
	// createSortOption("-rating", "Top Rated: Highest - Lowest", { field: "ratingValue", order: "desc" }),
]

export const defaultConfig = {
	sort: sortOptions[0],
	serpSize: sizes[2],
	autocompleteProductsSize: 6,
	autocompleteKeywordsSize: 4,
	historySize: 0
}

export const sizeOrder = [
	'XXS', 'XS', 'XS-S', 'XS/S', 'S', 'M', 'M-L', 'M/L', 'L', 'XL',
	'A', 'B', 'C', 'D', 'E', 
	'3-6 MONTHS', '6-12 MONTHS', '12-18 MONTHS',
	'2 YEARS', '4 YEARS', '6 YEARS', '8 YEARS', '10 YEARS', '12 YEARS',
	'00', '0', '2', '4', '5', '6', '7', '8', '9', '10', 
	'11', '12', '13', '14', '15', '16', '17', '18', '19', '20',
	'21', '22', '23', '24', '25', '26', '27', '28', '29',
	'30', '31', '32', '35', '35.5', '36', '36.5', '37', '37.5', '38', '38.5', '39', '39.5',
	'40', '40.5', '41', '41.5', '42', '44', '45', '46', '48',
	'One Size', 'OS'
];

export const searchSuggestionsFallback = [ 
	{
		text: "Dresses",
		url: "/collections/dresses",
	},
	{
		text: "Gowns",
		url: "/collections/gowns",
	},
	{
		text: "Tops",
		url: "/collections/tops",
	},
	{
		text: "Sandals",
		url: "/collections/sandals",
	},
	{
		text: "Bracelets",
		url: "/collections/bracelets",
	},
];

/* !! do not use if unsure how to set up !! */
export const facetConfigs = {
	"69029e3608ae1764ee59200c": { // facet id
		nameMap: { // change current filter values
			"true": "IN STOCK",
			"false": "hidden",
		},
		merge: [ // adds another facet's filter values to this facet group/dropdown
			{ 
				facetId: "690271838f821a797328e2f8", // other facet id
				isRange: true,
				newFilters: [
					{
						min: 1,
						max: 10,
						value: "ALMOST SOLD OUT", 
						id: 'almost-sold-out', // make sure it's unique to be used as .map() > key
					}
				]
			},
			{
				facetId: '6909033d9b9c797789c3d23d',
				isRange: false,
				newFilters: [
					{
						value: "PREORDER", // if not range, value must match exactly (case sensitive)
						id: 'preorder',
					}
				]
			}
		]
	},

	// for nested category filters, cannot use `merge`
	"6903c0a09639e0532335ab95": { hidden: true, nested: true, isFullValue: true, separator: ">", name: "Categories" },
	"6903a3fa9639e05323197ded": { hidden: true, nested: true, isFullValue: false },

	// prevent rendering separate dropdown, if merged
	"690271838f821a797328e2f8": { hidden: true }, 
	"6909033d9b9c797789c3d23d": { hidden: true },
}